import React from 'react'

export default function Socials() {
   return (
    <div className="social-buttons text-center">
          <ul className="social-network social-circle">
              <li><a href="tel:+31610735067" className="ico" title="Phone"><span className="social-text">+31(0)610735067</span> <i className="fa fa-phone"></i></a></li>
              <li><a href="https://www.linkedin.com/in/boris-polderman" className="ico" title="Linkedin"><span className="social-text">boris-polderman</span> <i className="fa fa-linkedin"></i></a></li>
              <li><a href="mailto:boris@bpolderman.com" className="ico" title="Mail"><span className="social-text">boris@bpolderman.com</span> <i className="fa fa-envelope"></i></a></li>
          </ul>
			</div>
  );
}
